const $togglerBtn = $(".password-toggler");
/**
* Hide/show password functionality
*/

function passwordShow () {
    const $this = $(this);
    const $input = $this.siblings(".form-control");
    const $eye = $this.children(".eye-icon");
    const $strikedEye = $this.children(".eye-icon-striked");

    if ($input.length) {
        const passwordType = $input.attr("type") === "password";
        $input.attr("type", passwordType ? "text" : "password");
        $eye.toggleClass("d-none");
        $strikedEye.toggleClass("d-none");
        $input.focus();
    }
}

export default function () {
    $togglerBtn.on("click", passwordShow);
}
